import { EventEmitter } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@env/environment';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
export class DocumentService {
    constructor(http) {
        this.http = http;
    }
    static pushProperty(property) {
        DocumentService.propertyPushed.emit(property);
    }
    paginateReferencesStudies(projectId, per_page = 5, page = 1, term = '') {
        return this.http.get(`${environment.base_url}/documents/${projectId}/references?page=${page}&per_page=${per_page}&q=${term}`);
    }
    getBySearchReferencesStudies(projectId, term = '') {
        return this.http.get(`${environment.base_url}/documents/${projectId}/search_references_studies?q=${term}`);
    }
    get(projectId, property = '') {
        return this.http.get(`${environment.base_url}/documents/${projectId}${property.length ? '/?only=' + property : '/'}`);
    }
    update(documentId, form) {
        return this.http.put(`${environment.base_url}/documents/${documentId}`, form);
    }
    uploadImage(projectId, file) {
        const payload = new FormData();
        payload.append('file', file);
        payload.append('project_id', JSON.stringify(projectId));
        return this.http.post(`${environment.base_url}/projects/images/upload`, payload, {
            reportProgress: true,
            observe: 'events'
        });
    }
    paginateImages(projectId, per_page = 10, page = 1) {
        return this.http.get(`${environment.base_url}/projects/${projectId}/images?page=${page}&per_page=${per_page}`);
    }
    deleteImage(id) {
        return this.http.delete(`${environment.base_url}/images/${id}`);
    }
    pdf(project_id, content) {
        const url = `${environment.base_url}/documents/pdf_gen`;
        // return this.http.get<Blob>(url, {
        //   observe: 'response',
        //   responseType: 'blob' as 'json'
        // });
        return this.http.post(url, { project_id, content }, {
            observe: 'events',
            responseType: 'blob',
            reportProgress: true
        });
    }
    countPages(projectId) {
        return this.http.get(`${environment.base_url}/documents/pdf/count_pages/${projectId}`);
    }
    sync(projectId, content) {
        return this.http.post(`${environment.base_url}/documents/sync`, {
            project_id: projectId,
            content
        });
    }
    checklistImage(projectId, base64) {
        return this.http.post(`${environment.base_url}/documents/checklist_image`, {
            projectId,
            checklist_html: base64
        });
    }
    uploadCatalogCardPdf(documentId, file) {
        const payload = new FormData();
        payload.append('file', file);
        payload.append('document_id', JSON.stringify(documentId));
        return this.http.post(`${environment.base_url}/documents/upload_catalog_card`, payload, {
            reportProgress: true,
            observe: 'events'
        });
    }
    uploadApprovalSheetPdf(documentId, file) {
        const payload = new FormData();
        payload.append('file', file);
        payload.append('document_id', JSON.stringify(documentId));
        return this.http.post(`${environment.base_url}/documents/upload_approval_sheet`, payload, {
            reportProgress: true,
            observe: 'events'
        });
    }
    uploadAppendiceOrAttachment(documentId, file, attachmentType = 'appendices_filename') {
        const payload = new FormData();
        payload.append('file', file);
        payload.append('document_id', JSON.stringify(documentId));
        payload.append('attachment_type', attachmentType);
        return this.http.post(`${environment.base_url}/documents/upload_appendice_or_attachment`, payload, {
            reportProgress: true,
            observe: 'events'
        });
    }
    /* Delete Appendices or Attachments */
    deleteAttachment(attachment) {
        return this.http.post(`${environment.base_url}/documents/delete_appendice_or_attachment`, attachment);
    }
    checkInUse(projectId, userId) {
        return this.http.get(`${environment.base_url}/documents/${projectId}/${userId}/check_in_use`);
    }
    enable(projectId, userId) {
        return this.http.get(`${environment.base_url}/documents/${projectId}/${userId}/enable`);
    }
    saveHistory(projectId) {
        return this.http.post(`${environment.base_url}/documents/save_history`, {
            project_id: projectId
        });
    }
    // getAllHistory(projectId: number): Observable<any> {
    //   return this.http.get(`${environment.base_url}/documents/${projectId}/get_all_history`);
    // }
    getAllHistory(projectId, perPage = 20, page = 1, from = '', till = '') {
        return this.http.get(`${environment.base_url}/documents/${projectId}/get_all_history?page=${page}&per_page=${perPage}&from=${from}&till=${till}`);
    }
    restoreHistory(docHistoryId) {
        return this.http.get(`${environment.base_url}/documents/${docHistoryId}/restore_history`);
    }
    getStudies(projectId, searchTerm) {
        return this.http.get(`${environment.base_url}/documents/${projectId}/get_references?q=${searchTerm}`);
    }
}
DocumentService.propertyPushed = new EventEmitter();
DocumentService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function DocumentService_Factory() { return new DocumentService(i0.ɵɵinject(i1.HttpClient)); }, token: DocumentService, providedIn: "root" });
